import { useContext } from 'react';

import { AuthContextValue, RootContext } from '@/router/state/root/util/context/root-context';

export function useRootContext() {
  const ctx = useContext(RootContext);
  if (!ctx) throw new Error('useRootContext must be used within RootContextProvider');
  return ctx;
}

export function useRootActorRef() {
  return useRootContext().actorRef;
}

export function useRootSelector<T>(selector: (state: AuthContextValue['state']) => T): T {
  const { state } = useRootContext();
  return selector(state);
}
